import { useApp } from "@/AppProvider"
import { Toast } from "./common"

export const Toasts = () => {
  const { toasts } = useApp()
  return (
    <div
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 z-80 flex items-end px-4 py-6 sm:items-start sm:p-6">
      <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
        {toasts
          .slice()
          .reverse()
          .map((toast, i) => (
            <Toast key={`toast_${toast.timestamp}_${i}`} toast={toast} />
          ))}
      </div>
    </div>
  )
}
